export default IconBedFlat => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bed-flat" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
  <path d="M10 13h11v-2a3 3 0 0 0 -3 -3h-8v5z" />
  <path d="M3 16h18" />
</svg>`;